<template>
  <v-container class="py-0">
    <v-row>
      <v-col>
        <div class="display-1 font-weight-normal mb-6 text-center">
          Vamos selecionar as etapas do cálculo que serão executadas
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <validation-provider
          v-slot="{ errors, valid }"
          rules="required"
          :custom-messages="{
            required: 'Selecione pelo menos uma etapa para continuar.'
          }"
        >
          <validation-helper
            :interceptor="valid"
            @isValid="
              $emit('step-observer-etapas', {
                step: 'etapas',
                complete: $event
              })
            "
          />
          <v-checkbox
            v-for="step in steps"
            :key="step.value"
            v-model="selectedSteps"
            :value="step.value"
            :error-messages="errors"
            @change="handleCheckboxChange(step.value)"
          >
            <template v-slot:label>
              <span class="checkbox-label">
                {{ step.label }}
              </span>
            </template>
          </v-checkbox>
        </validation-provider>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    components: {
      ValidationHelper: () => import('@/components/general/ValidationHelper.vue')
    },

    emits: ['step-observer-etapas', 'change-etapas'],

    data() {
      return {
        selectedSteps: [],
        steps: [
          { label: 'AIS', value: 'analise_ais', dependsOn: [] },
          { label: 'BDGD', value: 'base_fisica', dependsOn: [] },
          { label: 'ICMS', value: 'financeiro_do_icms', dependsOn: [] },
          {
            label: 'Banco de Compras',
            value: 'banco_de_compras',
            dependsOn: ['financeiro_do_icms']
          },
          {
            label: 'Base Incremental',
            value: 'base_incremental',
            dependsOn: ['banco_de_compras']
          },
          {
            label: 'Obrigações Especiais',
            value: 'obrigacoes_especiais',
            dependsOn: ['base_incremental']
          },
          {
            label: 'Base Blindada',
            value: 'base_blindada',
            dependsOn: ['obrigacoes_especiais']
          }
        ]
      };
    },

    created() {
      this.selectedSteps = this.steps.map((step) => step.value);
      this.$emit('change-etapas', this.selectedSteps);
    },

    methods: {
      selectStep(value) {
        if (!this.selectedSteps.includes(value)) this.selectedSteps.push(value);
      },

      deselectStep(value) {
        this.selectedSteps = this.selectedSteps.filter((step) => step !== value);
      },

      handleCheckboxChange(value) {
        this.changeStep(value);
        this.$emit('change-etapas', this.selectedSteps);
      },

      changeStep(value) {
        const step = this.steps.find((s) => s.value === value);

        if (!step) {
          console.warn('Checkbox value not found: ', value);
          return;
        }

        if (this.selectedSteps.includes(value)) {
          step.dependsOn.forEach((dependency) => {
            this.selectStep(dependency);
            this.changeStep(dependency);
          });
        } else {
          this.steps.forEach((s) => {
            if (s.dependsOn.includes(value)) {
              this.deselectStep(s.value);
              this.changeStep(s.value);
            }
          });
        }
      },

      exportData() {
        return {
          etapasSelecionadas: this.selectedSteps
        };
      }
    }
  };
</script>

<style>
  .checkbox-label {
    color: #6e6e6e;
    font-size: 14px;
    font-weight: 400;
  }

  .error--text .checkbox-label {
    color: inherit;
  }
</style>
